var $ce40f46d09034645$exports = {};
$ce40f46d09034645$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "V\u0113rt\u012Bbai ir j\u0101b\u016Bt ".concat(args.maxValue, " vai agr\u0101kai.");
  },
  "rangeReversed": "S\u0101kuma datumam ir j\u0101b\u016Bt pirms beigu datuma.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "V\u0113rt\u012Bbai ir j\u0101b\u016Bt ".concat(args.minValue, " vai v\u0113l\u0101kai.");
  },
  "unavailableDate": "Atlas\u012Btais datums nav pieejams."
};
export { $ce40f46d09034645$exports as default };